import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { CustomerBillingOtherCustomerModel } from '@fi-app/customer-billing/customer-billing-other-customer/customer-billing-other-customer.model';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'fi-customer-billing-reseller-payment-info',
    template: `
        <div class="GroupHeader form-group">
            <span class="Ccm-Label-Wide Bold">{{ 'payment_information' | fiAppText }}</span>
        </div>
        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'billing.customer_type' | fiAppText }}</mat-label>
                <input matInput [value]="ngModel.CustomerType | fiCustomerTypeName" disabled />
            </mat-form-field>
        </div>
        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'billing.payment_method' | fiAppText }}</mat-label>
                <input matInput [value]="ngModel.PaymentMethodType | fiPaymentMethodTypeName" disabled />
            </mat-form-field>
        </div>
        <div class="form-group full-width-material">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'customer_billing.reseller_discount' | fiAppText }}, %</mat-label>
                <input matInput [(ngModel)]="ngModel.DiscountGlobal" required />
                <mat-error>{{ 'common_error.mandatory' | fiAppText }}</mat-error>
            </mat-form-field>
        </div>
    `,
    styleUrls: ['./customer-billing-reseller-payment-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: CustomerBillingResellerPaymentInfoComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: CustomerBillingResellerPaymentInfoComponent,
        },
    ],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-reseller-payment-info' },
    standalone: false,
})
export class CustomerBillingResellerPaymentInfoComponent extends ControlValueAccessorValidatorBase<CustomerBillingOtherCustomerModel> {}
